import workspaceQuery from '../../queries/salesLedger/SalesReceiptWorkspaceQuery.graphql';
import listQuery from '../../queries/salesLedger/SalesReceiptListQuery.graphql';
import instanceQuery from '../../queries/salesLedger/SalesReceiptQuery.graphql';
import defaultQuery from '../../queries/salesLedger/SalesReceiptDefault.graphql';
import mutationQuery from '../../mutations/salesLedger/SalesReceiptMutation.graphql';
import temporaryMutationQuery from '../../mutations/salesLedger/SaveSalesReceiptTempMutation.graphql';
import aggregateQuery from '../../queries/salesLedger/SalesReceiptAggregateQuery.graphql';
import fragment from '../../fragments/salesLedger/SalesReceiptFragment.graphql';

import { formActionsForPermissions } from '../../../actions/salesLedger/SalesReceiptAction';
import { EntityType } from '../../../@types/entityTypes';
import { DocumentType } from '../../schema/p4types';

const SalesReceipt: EntityType = {
  type: 'SalesReceipt',
  title: 'Customer Receipts',
  formTitle: 'Customer Receipt',
  formUrl: '/Customers/Receipt/Details/',
  workspaceUrl: '/Customers/Receipt/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'documentNumber',
  },
  aggregate: aggregateQuery,
  fragment,
  screenReference: 'SALES_LEDGER_RECEIPTS',
  actions: formActionsForPermissions,
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED'],
    },
  ],
  documentType: DocumentType.SalesReceipt,
};

export default SalesReceipt;
